// extracted by mini-css-extract-plugin
export default {"content":"PageNotFound_content__btwEn","text":"PageNotFound_text__fKwQU","button":"PageNotFound_button__G2qbV"};